/* Register der automatischen Lösungen (ADR 0003): eine Stelle für Namen, Texte und Eigenschaften jeder Lösung.
 * Prüf-Dialog, Kommandozeile (xf fix) und Skills lesen alle von hier; die Anwendung steht in checkfix.ts. Ohne DOM. */
import type { CheckFix } from './types.ts';

export interface FixInfo {
  /** Übersetzungsschlüssel: Schaltfläche, Erklärung, Name des Undo-Schritts */
  label: string; info: string; cmd: string;
  /** true: wird von „alle lösbaren“ (applyFixes ohne IDs, xf fix ohne --id) mitgelöst. false: ändert das Spielverhalten und braucht eine ausdrückliche Wahl */
  auto: boolean;
}
export const FIXES: Record<CheckFix, FixInfo> = {
  delete: { label: 'chk.fix_delete', info: 'chk.fix_info_delete', cmd: 'cmd.delete', auto: true },
  detail: { label: 'chk.fix_detail', info: 'chk.fix_info_detail', cmd: 'cmd.to_detail', auto: true },
  null: { label: 'chk.fix_null', info: 'chk.fix_info_null', cmd: 'cmd.to_null', auto: true },
  snap: { label: 'chk.fix_snap', info: 'chk.fix_info_snap', cmd: 'cmd.snap_grid', auto: true },
  skip: { label: 'chk.fix_skip', info: 'chk.fix_info_skip', cmd: 'cmd.to_skip', auto: true },
  texalign: { label: 'chk.fix_texalign', info: 'chk.fix_info_texalign', cmd: 'cmd.to_texalign', auto: true },
  zfight: { label: 'chk.fix_zfight', info: 'chk.fix_info_zfight', cmd: 'cmd.to_zfight', auto: true },
  fgd: { label: 'chk.fix_fgd', info: 'chk.fix_info_fgd', cmd: 'cmd.to_fgd', auto: false },
  hull: { label: 'chk.fix_hull', info: 'chk.fix_info_hull', cmd: 'cmd.to_hull', auto: false },
  noclip: { label: 'chk.fix_noclip', info: 'chk.fix_info_noclip', cmd: 'cmd.to_noclip', auto: false }
};
export const FIX_IDS = Object.keys(FIXES) as CheckFix[];
export const isAutoFix = (f: CheckFix): boolean => FIXES[f].auto;
